import Results from "./Results";
import Input from "./Input";
import React from "react";

import lockupWhite from "../../assets/wmu-lockup-white.svg";
import StatsSection from "../home/StatsSection";
import ExplainerSection from "../home/ExplainerSection";

function Search() {
    return (
      <div className="App-search">
        <section className="Hero">
          <img className="Hero-logo" src={ lockupWhite } alt="what's my uprn?" />
          <p className="Hero-tagline">
            The free lookup for Unique Property Reference Numbers —
            covering <strong>every address</strong>, <strong>every building</strong> and{" "}
            <strong>every block of flats</strong> in Great Britain.
          </p>
          <div className="Hero-search">
            <Input />
            <p className="Hero-search-hint">
              Try an address, a building name or a postcode — e.g. &ldquo;10 Downing Street&rdquo;
            </p>
          </div>
          <div className="Hero-results">
            <Results />
          </div>
        </section>
        <StatsSection />
        <ExplainerSection />
      </div>
    );
}

export default Search;
